import { createSelector } from 'reselect'
import { selectors as imported } from '../../imports'

export const getTokens = state => state.usersReducer.tokens

export const getActiveTokens = createSelector(
    [getTokens, imported.getActiveServerId],
    (tokens, serverId) => tokens[serverId] || {},
)

export const getUserTokens = (state, serverId, userId) => {
    const tokens = getTokens(state)
    const server = tokens[serverId] || {}
    return server[userId] || { access: '', refresh: '' }
}

export const getActiveUserTokens = (state, userId) => {
    const server = getActiveTokens(state)
    return server[userId] || { access: '', refresh: '' }
}

export const getUserAccessToken = (state, serverId, userId) =>
    getUserTokens(state, serverId, userId).access

export const getUserRefreshToken = (state, serverId, userId) =>
    getUserTokens(state, serverId, userId).refresh

export const getActiveUserAccessToken = (state, userId) => getActiveUserTokens(state, userId).access

export const getActiveUserRefreshToken = (state, userId) =>
    getActiveUserTokens(state, userId).refresh



// WEBPACK FOOTER //
// ./src/features/Users/data/tokens/selectors.js